import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { submissionsInFillingProcessApi } from '@api';
import { CreateSubmissionDto } from '@app-types';

const useCreateSubmissionInFillingProcess = (options?: UseMutationOptions<AxiosResponse, unknown, CreateSubmissionDto>) => {
  return useMutation({
    ...options,
    mutationFn: submissionsInFillingProcessApi.createSubmissionInFillingProcess,
  });
};

export default useCreateSubmissionInFillingProcess;
